import { FC } from 'react'
import classNames from 'classnames'

import { Loading } from '../../global/Loading/Loading'
import { TextH2, TextSmall } from '../../ui/Typography/Typography'
import { placeholder } from '../../utils/placeholder'

import styles from './RebatesSummary.module.scss'

export interface SummaryItem {
  title: string
  value: string | number
}

export interface RebatesSummaryProps {
  summaryItems: SummaryItem[]
  isLoading?: boolean
}

export const RebatesSummary: FC<RebatesSummaryProps> = ({ summaryItems, isLoading }) => {
  const hasOddChildren = summaryItems.length % 2 !== 0

  return (
    <div className={styles.rebatesSummary}>
      <Loading wrapperClass={styles.loading} isLoading={!!isLoading} showLoadingIcon>
        {summaryItems.map(({ title, value }) => (
          <div
            key={title}
            className={classNames(styles.summaryItem, {
              [styles.odd]: hasOddChildren,
            })}
          >
            <TextH2 className={styles.value}>{placeholder.dash(value)}</TextH2>
            <TextSmall className={styles.title}>{title}</TextSmall>
          </div>
        ))}
      </Loading>
    </div>
  )
}
